import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const ModalWrapper = styled.div`
  display: flex;
  position: fixed;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1300;
  background-color: rgba(26, 26, 30, 0.5);
`

export const ModalContent = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  max-width: 540px;
  padding: ${theme.spacing.xl} ${theme.spacing['2xl']};
  border-radius: ${theme.shapes.borderRadius.md};
  background: ${theme.colors.neutral.white};
`
